import FragmentPage from '../core/FragmentPage';
import { initResponsiveSlides } from '../services/slider';

export default class IndexPage extends FragmentPage {
  constructor(meta) {
    super('index', meta, { contentFile: 'index.content.html' });
  }

  async onEnter() {
    initResponsiveSlides({ auto: true });
  }
}
